import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  applyTheme,
  isTelegramLaunch,
  loadTelegram,
  markTelegram,
  readFlag,
  type TgWebApp,
} from "@/lib/telegram";

const ROOTS = new Set(["/", "/my", "/tg"]);

/** Telegram ichida ochilganda: mavzuni moslaydi, to'liq ekranga kengaytiradi va "Orqaga" tugmasini sahifalarga ulaydi. */
export function TelegramBridge() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const app = useRef<TgWebApp | null>(null);
  const back = useRef(() => navigate(-1));
  useEffect(() => {
    back.current = () => navigate(-1);
  }, [navigate]);

  useEffect(() => {
    if (!isTelegramLaunch(window.location.hash, readFlag())) return;
    let cancelled = false;
    let cleanup: (() => void) | undefined;
    void loadTelegram().then((w) => {
      if (!w || cancelled) return;
      markTelegram();
      app.current = w;
      w.ready();
      w.expand();
      applyTheme(w);
      const onTheme = () => applyTheme(w);
      const onBack = () => back.current();
      w.onEvent("themeChanged", onTheme);
      w.BackButton.onClick(onBack);
      cleanup = () => {
        w.offEvent("themeChanged", onTheme);
        w.BackButton.offClick(onBack);
      };
      if (!ROOTS.has(window.location.pathname)) w.BackButton.show();
    });
    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, []);

  useEffect(() => {
    const w = app.current;
    if (!w) return;
    if (ROOTS.has(pathname)) w.BackButton.hide();
    else w.BackButton.show();
  }, [pathname]);

  return null;
}
